"use client";

import { HomeQueryParam } from "@/constants/navigation.enum";

const HOME_PATH = "/";

/** The param is a presence marker, so its one written value is a bare flag;
 *  the consumer treats any non-empty value as the marker. */
const ALL_TEAMS_GALLERY_FLAG = "1";

/**
 * The landing PATH that opens the All Teams gallery — the form a router push
 * wants. Written by the session-start chooser's "Existing team" option when
 * the landing is not mounted; consumed ONCE by the landing's
 * `useAllTeamsGalleryUrlRestore` and stripped, like the other one-shot
 * restores. It deliberately carries no other params: the gallery is the
 * landing's base surface, not a team-modal state, so it never joins the
 * `?viewTeam` grammar.
 */
export function buildAllTeamsGalleryPath(): string {
  const params = new URLSearchParams();
  params.set(HomeQueryParam.AllTeamsGallery, ALL_TEAMS_GALLERY_FLAG);
  return `${HOME_PATH}?${params.toString()}`;
}

/**
 * Drop the one-shot gallery param, keeping every other param in place. Direct
 * `history.replaceState` is the landing URL family's idiom (`setViewTeamUrl`):
 * the strip must not re-enter the router while the arrival navigation that
 * delivered the param is still settling.
 */
export function stripAllTeamsGalleryUrl(): void {
  const params = new URLSearchParams(window.location.search);
  if (params.get(HomeQueryParam.AllTeamsGallery) == null) return;
  params.delete(HomeQueryParam.AllTeamsGallery);

  const nextUrl = params.toString()
    ? `${window.location.pathname}?${params.toString()}`
    : window.location.pathname;
  window.history.replaceState(null, "", nextUrl);
}
